import {Component, HostBinding} from '@angular/core';
import {FormArray, FormBuilder, FormGroup} from '@angular/forms';
import {ReflexiveRestModel} from '../../reflexive-model/reflexive-rest-model';
import {GeliosFieldBaseComponent} from '../gelios-field-base/gelios-field-base.component';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-gelios-array-column-field',
  templateUrl: './gelios-array-column-field.component.html',
  styleUrls: ['./gelios-array-column-field.component.scss']
})
export class GeliosArrayColumnFieldComponent extends GeliosFieldBaseComponent {
  @HostBinding('class.form__object-field') classFormAndButtonsContainer = true;

  constructor(
    protected translate: TranslateService,
    protected formBuilder: FormBuilder,
  ) {
    super(translate);
  }

  showChildField(model: ReflexiveRestModel, fieldName: string, formGroup: FormGroup): boolean {
    return model && model.fields[fieldName] &&
      (!model.fields[fieldName].isVisible || model.fields[fieldName].isVisible(formGroup));
  }

  addNewChild() {
    const {fields} = this.model;
    const {[this.fieldName]: fieldConfig} = fields;
    const {createChild, fields: childFields} = fieldConfig.reflexiveModelArrayColumnField;

    const model = createChild();
    const fieldValue = fieldConfig.value || [];

    fieldValue.push(model);
    fieldConfig.value = fieldValue;

    const newFormGroup = model.getFormGroup(this.formBuilder, childFields);
    const formArray = this.formGroup.controls[this.fieldName] as FormArray;

    formArray.push(newFormGroup);
    formArray.markAsTouched();
    formArray.updateValueAndValidity();
  }

  getFormGroups(formGroup: FormGroup): Array<FormGroup> {
    return (formGroup.get(this.fieldName) as FormArray).controls as Array<FormGroup>;
  }

  removeChild(index: number) {
    const formArray = this.formGroup.controls[this.fieldName] as FormArray;
    const fieldValue = this.model.fields[this.fieldName].value as Array<ReflexiveRestModel>;

    formArray.removeAt(index);
    fieldValue.splice(index, 1);

    formArray.markAsTouched();
    formArray.updateValueAndValidity();

    if (this.model.fields[this.fieldName].reflexiveModelArrayColumnField.onChildRemoved) {
      this.model.fields[this.fieldName].reflexiveModelArrayColumnField.onChildRemoved(
        this.formGroup.controls[this.fieldName] as FormArray,
      );
    }
  }

  allowRemoveModel(childFormGroup: FormGroup): boolean {
    return this.reflexiveField
      && this.reflexiveField.reflexiveModelArrayColumnField
      && this.reflexiveField.reflexiveModelArrayColumnField.allowRemoveModel(childFormGroup);
  }
}
